export default class Milestone {
    milestoneId!:string;
    projectId!:string;
    name!:string;
    type!:number;
    deliverableDate!:Date;
    status!:number;
    description!:string;
}